import type { TutorBillingReturnStore } from './interfaces'

export const getters = {
  getReturnPath: (state: TutorBillingReturnStore): TutorBillingReturnStore['returnPath'] => state.returnPath,
}
